import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { appStore, traceApiStore, editTraceStore } from "@/hooks";
import {
  FlexBox,
  PanelCard,
  TextButton,
  DetailsPanel,
  TextInput,
} from "@/components/common";

/**
 * Creates a trace link from the given artifacts.
 */

/**
 * Allows for editing trace links.
 */
const __default__ = {
  name: "EditTraceLinkPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

async function handleSubmit(): Promise<void> {
  await traceApiStore.handleEdit(editTraceStore.editedTrace, {
    onSuccess: () => {
      appStore.closeSidePanels();
      editTraceStore.resetTrace(undefined);
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "editTrace",
    "data-cy": "panel-trace-edit"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        label: "View Trace Link",
        icon: "trace",
        "data-cy": "button-trace-view",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('displayTrace')))
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        title: "Save Trace Link",
        borderless: ""
      }, {
        actions: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            "full-width": "",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), {
                label: "Save",
                icon: "save",
                color: "primary",
                loading: _unref(traceApiStore).editLoading,
                "data-cy": "button-trace-edit",
                onClick: handleSubmit
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(TextInput), {
            modelValue: _unref(editTraceStore).editedTrace.explanation,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(editTraceStore).editedTrace.explanation) = $event)),
            label: "Explanation",
            type: "textarea"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})